import { callApi } from '@/api/apibase'

export const getCourseById = function (courseId) {
  return callApi('GET', `/api/external/greencourse/getByCourseId?courseId=${courseId}`)
}
